import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CreateSalaryPaymentsDto } from "../../../dtos/documents/SalaryPayments/CreateSalaryPaymentsDto";
import { SalaryPaymentsDetail } from "../../../components/Pages/Documents/SalaryPayments/SalaryPaymentsDetail";
import SalaryPaymentsList from "../../../components/Pages/Documents/SalaryPayments/SalaryPaymentsList";
import { NFLookupSalaryPayments } from "../../../components/Shared/NewForms/NFLookupSalaryPayments";
import { SalaryPaymentsService } from "../../../services/documents/SalaryPaymentsService";

export const SalaryPayments: IAppEntity = {
  entityType: "document",
  title: "Salary Payments",
  pluralTitle: "Salary Payments",
  apiUrl: "SalaryPayments",
  apiEnum: ReferenceTypes.DocumentSalaryPayment,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(SalaryPaymentsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(SalaryPaymentsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupSalaryPayments, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new SalaryPaymentsService("SalaryPayments"),
  getEmptyModel: () => {
    const model: CreateSalaryPaymentsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate:new Date(),
      month:"",
      salaryPaymentPayments: [],
    };
    return model;
  },
};
